import { NextImage } from '@research-api/utils/api/ghost/ghost-interfaces';

const nextImageFromUrl = (url: string, width: number, height: number): NextImage | null => {
    return {
        url,
        dimensions: {
            width,
            height,
        },
    };
};

export default nextImageFromUrl;
